import Input, { InputProps } from './Input'

export default Input
export type { InputProps }